/**
 * Theme Requirements Aggregation for Weidner Apartment Homes Rise
 * 
 * Extends the base rise theme requirements with Weidner Apartment Homes Rise specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-rise/requirements';

/**
 * Weidner Apartment Homes Rise component requirement overrides.
 * Add requirements for any override components here.
 */
const weidnerapartmenthomesriseOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Weidner Apartment Homes Rise theme.
 * Inherits from rise theme and overrides with Weidner Apartment Homes Rise components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...weidnerapartmenthomesriseOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
